<template>
    <div class="px-sm flex flex-col">
        <div
            v-if="links && links?.length > 1"
            class="-mx-sm px-sm py-xs flex cursor-pointer items-center justify-between rounded-sm transition-all"
            :class="{ 'mb-xs': isDropdownOpen }"
            tabindex="0"
            @click="toggleDropdown"
            @keydown.enter.prevent="toggleDropdown"
        >
            <span
                class="gap-sm text-md font-md text-primary pointer-events-none flex items-center"
                :class="{ 'text-lg!': mobile }"
            >
                <i :class="['size-5', icon, { 'size-6': mobile }]" />
                {{ category }}
            </span>
            <span v-if="links && links?.length > 1" class="flex items-center">
                <i
                    class="i-sidemenu-chevron text-primary h-2 w-3 bg-contain bg-no-repeat brightness-0 transition-transform"
                    :class="{ 'rotate-180': !isDropdownOpen }"
                />
            </span>
        </div>

        <Transition v-show="links && links.length > 1" name="dropdown">
            <div v-if="isDropdownOpen" class="gap-xs relative flex flex-col pl-5">
                <router-link
                    v-for="link in links"
                    :key="link.to"
                    :to="resolveSideMenuRouteLocation(link.to, link.query)"
                    active-class="bg-surface-hover"
                    class="py-xs gap-sm px-sm flex items-center rounded-sm transition-colors hover:bg-surface-hover"
                    @click="$emit('close')"
                >
                    <p class="text-md text-primary">{{ link.title }}</p>
                </router-link>
                <!-- border-strong, not -subtle: the guide line sits on the tinted menu
                     surface, where the subtle hairline (tuned for white) disappears. -->
                <span class="absolute top-0 left-[0.6rem] h-full w-px rounded-md bg-[var(--border-strong)]"></span>
            </div>
        </Transition>

        <router-link
            v-if="links && links.length === 1"
            :to="resolveSideMenuRouteLocation(links?.[0].to ?? '', links?.[0].query)"
            active-class="bg-surface-hover"
            class="-mx-sm px-sm py-xs flex cursor-pointer items-center justify-between rounded-sm transition-all hover:bg-surface-hover"
            :class="{ 'mb-xs': isDropdownOpen }"
            @click="$emit('close')"
        >
            <span class="gap-sm text-md text-primary flex items-center font-medium">
                <i :class="['size-5', icon, { 'size-6': mobile }]" />
                <p class="text-md font-md text-primary" :class="{ 'text-lg!': mobile }">{{ links?.[0].title }}</p>
            </span>
        </router-link>
    </div>
</template>

<script lang="ts" setup>
import type { LocationQueryRaw } from 'vue-router';
import { ref, type PropType } from 'vue';
import { resolveSideMenuRouteLocation } from '@/components/misc/side-menu-link';

defineEmits<{ close: [] }>();

const props = defineProps({
    category: String,
    icon: String,
    links: Array as PropType<
        Array<{
            title: string;
            to: string;
            props?: Record<string, string>[];
            query?: LocationQueryRaw;
        }>
    >,
    mobile: Boolean,
});

const isDropdownOpen = ref(props.mobile ? false : true);

const toggleDropdown = () => {
    isDropdownOpen.value = !isDropdownOpen.value;
};
</script>

<style>
@reference '@/assets/styles/default.css';

.dropdown-enter-active,
.dropdown-leave-active {
    transition: all 0.3s;
    max-height: 22rem;
}

.dropdown-enter-from,
.dropdown-leave-to {
    opacity: 0;
    max-height: 0;
    transform: translateY(-10px);
}

.dark .i-sidemenu-chevron {
    filter: brightness(0) invert(1);
}
</style>
